import OffersSDK from './dist/offers';

export default OffersSDK;
export * from './dist/offers';
